import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { ConfigContext } from "States/config/configState";
import { i18nextKeys } from "Lang/i18nextKeys";
import i18nextTranslate from "Lang/i18nextTranslate";
import Urls from "Utils/urls";

const SidebarLogo = () => {
  const { config } = useContext(ConfigContext);
  const link = i18nextTranslate(i18nextKeys.sidebarLogoLink, { returnObjects: true });
  const customerLogo = (
    <img
      data-qa="sidebar-logo"
      className="color-7 pl-10 md:pl-0"
      style={{
        width: '45px'
      }}
      src={`${Urls.get()?.blob}/${config?.logo}`}
      alt="Company Logo"
    />
  );
  if (
    !link?.enabled
    || (link?.external && !link?.url)
    || (!link?.external && !link?.path)
  ) {
    return customerLogo;
  }
  return link.external ? (
    <a
      href={link?.url}
      target={link?.newTab ? "_blank" : "_self"}
      rel="noopener noreferrer"
      data-qa="sidebar-logo-link"
    >
      {customerLogo}
    </a>
  ) : (
    <Link
      to={link?.path}
      target={link?.newTab ? "_blank" : "_self"}
      data-qa="sidebar-logo-link"
    >
      {customerLogo}
    </Link>
  );
};

export default SidebarLogo;
